import getLang from 'I18n/utils/getLang';
import { AppContextType } from 'marketplace-ui-common/types';
import { useGetInstallabilityQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsRpc-app.hooks';

export interface UseInstallabilityProps {
  listingId?: number;
  published?: boolean;
  skip?: boolean;
  appContext: AppContextType;
}

export function useInstallability({
  listingId,
  published = true,
  skip = false,
  appContext,
}: UseInstallabilityProps) {
  const {
    data: installabilityData,
    loading: installabilityLoading,
    error: installabilityError,
    refetch: refetchInstallability,
  } = useGetInstallabilityQuery({
    variables: {
      listingId: listingId!,
      listingLanguage: getLang(),
      published,
    },
    skip: skip || !listingId || appContext !== 'app',
  });

  return {
    data: installabilityData,
    loading: installabilityLoading,
    error: installabilityError,
    refetch: refetchInstallability,
  };
}
